import { create } from 'zustand';
import { deleteEngineer, getEngineers } from '../../../api/api';
import { toast } from 'react-toastify';

export const useEngineersStore = create((set, get) => ({
  data: [],
  isLoading: false,
  error: null,
  total: 0,

  fetchEngineers: async (page, limit, sort_column) => {
    set({ isLoading: true, error: null });

    await getEngineers(
      page,
      limit,
      sort_column,
      (data) => {
        set({ data: data?.items, total: data?.full_count, isLoading: false });
      },
      (err) => {
        set({ error: err, isLoading: false });
      }
    );
  },

  // delete:
  resetDeleteData: () => {
    set({ deleteId: null, deleteEngineerName: null });
  },

  deleteModal: false,
  setDeleteModal: (deleteModal) => {
    set({ deleteModal });
  },

  deleteId: null,
  deleteEngineerName: null,
  setDeleteData: ({ id, name, deleteModal }) => {
    set({ deleteId: id, deleteEngineerName: name, deleteModal });
  },

  removeEngineer: async () => {
    const id = get().deleteId;
    if (id) {
      await deleteEngineer(
        id,
        () => {
          toast.success('Инженер удален из системы');
          get().fetchEngineers();
        },
        (err) => {
          toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
        }
      );
    }

    set({ deleteId: null, deleteModal: false });
  },
}));
